export default __webpack_public_path__ + "static/media/math-multipart-cloze-blue.d99b6053.svg";